import { createFileRoute } from '@tanstack/react-router';
import { InitialLoadPage } from '@features/admin/initial-load';

export const Route = createFileRoute('/admin/initial-load/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <InitialLoadPage />;
}
